// Canonical plan data for every public + dashboard pricing surface.
//
// Before this file existed, prices/limits/trial length were hardcoded in
// LandingPage, BillingPagePaddle, translations.js and public/index.html, and had
// already drifted (billing page advertised a 7-day trial, marked Pro "popular",
// and offered the trial on Starter). Anything that renders a price, a limit, or
// a trial length must read from here.
//
// Must stay in sync with the backend, which is authoritative for enforcement:
//   backend/controllers/usageController.js  -> PLAN_LIMITS
//   backend/config/lemonSqueezy.js          -> prices + LS variant IDs
//   backend/controllers/authController.js   -> TRIAL_DAYS
//
// Feature *copy* stays in src/i18n/translations.js so it can be localized; the
// numbers behind that copy live here.

// Trial: 14 days, no credit card, Basic plan only.
// Starter and Pro are direct-purchase (see faq.q1.a in translations.js).
export const TRIAL_DAYS = 14;
export const TRIAL_PLAN = "basic";

// Counting is per-conversation: a conversation is one chat session, closed after
// 30 minutes of inactivity. The backend field is still named `messagesPerMonth`
// for API back-compat, but it counts distinct session ids.
export const PLANS = [
    {
        slug: "starter",
        name: "Starter",
        monthlyPrice: 7.99,
        annualTotal: 79,
        popular: false,
        trial: false,
        limits: { conversations: 500, sources: 3, characters: 25000 },
    },
    {
        slug: "basic",
        name: "Basic",
        monthlyPrice: 19.99,
        annualTotal: 199,
        popular: true,
        trial: true,
        limits: { conversations: 2000, sources: 10, characters: 100000 },
    },
    {
        slug: "pro",
        name: "Pro",
        monthlyPrice: 39.99,
        annualTotal: 399,
        popular: false,
        trial: false,
        // sources: -1 means unlimited, matching the backend convention.
        limits: { conversations: 8000, sources: -1, characters: 200000 },
    },
];

// Effective per-month price when billed annually, e.g. $79/yr -> $6.58/mo.
export const annualMonthlyPrice = (plan) => Math.round((plan.annualTotal / 12) * 100) / 100;

export const getPlan = (slug) => PLANS.find((p) => p.slug === String(slug).toLowerCase()) || null;

// Rounded whole-percent saving from paying annually, used for the billing toggle badge.
export const annualSavingsPercent = (plan) =>
    Math.round((1 - plan.annualTotal / (plan.monthlyPrice * 12)) * 100);

export const PRICE_RANGE = {
    low: Math.min(...PLANS.map((p) => p.monthlyPrice)),
    high: Math.max(...PLANS.map((p) => p.monthlyPrice)),
};

export default PLANS;
